module.exports = {
  "personnelManager": {
    "personnelManager": "用户管理",
    personnelList: "用户列表",
    personnelName: "用户姓名",
    personnelNameHint: "请输入用户姓名",
    "affiliatedOrganizationHint": "请选择所属组织",
    account: "登录账号",
    "lastLoginTime": "上次登录时间",
    "role": "角色",
    "roleHint": "请选择角色",
    "deletePersonnelHint": "删除该用户 {0} 将不可恢复，确定吗？",
    "addPersonnel": "添加用户",
    "editPersonnel": "编辑用户",
    reUpload: "重新上传",
    clickUpload: "点击上传",
    userPicture: "用户头像",
    "baseInformation": "基本信息",
    "phoneNumber": "手机号码",
    "telphoneHint": "请输入手机号码",
    "orgHint": "请选择所属组织",
    "email": "电子邮箱",
    "emailHint": "请输入电子邮箱",
    "reportingRange": "重置密码",
    "reportingRangeHint": "重置密码成功，密码123456",
    "perSelection": "人员选择",
    "userProfile": "用户档案",
    "personalInformation": "个人信息",
    "warningRecords": "预警记录",
    "dateOfBirth": "出生日期",
    "dateOfBirthHint": "请选择出生日期",
    "theOnlyChild": "独生子女",
    "singleParentFamily": "单亲家庭",
    "healthCondition": "健康状况",
    "healthConditionHint": "请输入健康状况",
    "nation": "民族",
    "nationHint": "请输入民族",
    "nativePlace": "籍贯",
    "nativePlaceHint": "请输入籍贯",
    "homeAddress": "家庭地址",
    "homeAddressHint": "请输入家庭地址",
    "familyContacts": "家庭联系人",
    "familyContactsHint": "请输入家庭联系人",
    "contactMobile": "联系人手机",
    "contactMobileHint": "请输入联系人手机",
    "homePhone": "家庭电话",
    "homePhoneHint": "请输入家庭电话",
    "serialNumber": "编号",
    "serialNumberHint": "请输入编号",
    "selectPeopleNumber": "已选{0}人",
  },
};



// WEBPACK FOOTER //
// ./src/i18n/personnelManager/zh-CN.js